const BADGE_SHAPE = 'inline-flex rounded-full px-2 py-0.5 text-xs font-medium';
const UNKNOWN_STATUS_STYLE = 'bg-gray-100 text-gray-700';

const STATUS_PILLS: Record<string, { label: string; style: string }> = {
  awaiting_upload: { label: 'Scheduled', style: 'bg-blue-100 text-blue-700' },
  scheduled: { label: 'Scheduled', style: 'bg-blue-100 text-blue-700' },
  processing: { label: 'Processing', style: 'bg-yellow-100 text-yellow-800' },
  dispatched: { label: 'Sent', style: 'bg-green-100 text-green-700' },
  dispatched_with_errors: {
    label: 'Sent with errors',
    style: 'bg-orange-100 text-orange-800',
  },
  validation_failed: {
    label: 'Sheet rejected',
    style: 'bg-red-100 text-red-700',
  },
  cancelled: { label: 'Cancelled', style: 'bg-gray-100 text-gray-700' },
  failed: { label: 'Failed', style: 'bg-red-100 text-red-700' },
};

interface CampaignStatusBadgeProps {
  status: string;
}

export default function CampaignStatusBadge({
  status,
}: CampaignStatusBadgeProps) {
  const pill = STATUS_PILLS[status];

  if (!pill) {
    return (
      <span className={`${BADGE_SHAPE} ${UNKNOWN_STATUS_STYLE}`}>{status}</span>
    );
  }

  return <span className={`${BADGE_SHAPE} ${pill.style}`}>{pill.label}</span>;
}
